<template>
  <div class="footer mt-auto px-5 py-2">
    <the-alerts />
    <v-container fluid>
      <v-row>
        <v-col
          cols="12"
          lg="5"
          md="5"
          v-if="
            setting.find(
              (z) =>
                z.id == 10 ||
                z.id == 11 ||
                z.id == 12 ||
                z.id == 13 ||
                z.id == 14 ||
                z.id == 15
            )
          "
        >
          <h3>راه‌های ارتباطی</h3>
          <v-row class="mt-3 pr-3">
            <v-col
              cols="12"
              class="d-flex align-center pa-0"
              v-if="setting.find((z) => z.id == 13 && z.value)"
            >
              <v-icon class="ml-1" size="11pt" color="second">
                mdi-phone-outline
              </v-icon>
              <span>
                <small>
                  {{ setting.find((z) => z.id == 13).title }}: &nbsp;
                </small>
                <label class="p-fs-n">
                  {{ setting.find((z) => z.id == 13).value }}
                </label>
              </span>
            </v-col>

            <v-col
              cols="12"
              class="d-flex align-center pa-0"
              v-if="setting.find((z) => z.id == 14)"
            >
              <v-icon class="ml-1" size="11pt" color="second">
                mdi-email-outline
              </v-icon>
              <span>
                <small>
                  {{ setting.find((z) => z.id == 14).title }}: &nbsp;
                </small>
                <label class="p-fs-n">
                  {{ setting.find((z) => z.id == 14).value }}
                </label>
              </span>
            </v-col>

            <v-col
              cols="12"
              class="d-flex align-center pa-0"
              v-if="setting.find((z) => z.id == 15)"
            >
              <v-icon class="ml-1" size="11pt" color="second">
                mdi-map-marker-outline
              </v-icon>
              <span>
                <small>
                  {{ setting.find((z) => z.id == 15).title }}: &nbsp;
                </small>
                <label class="p-fs-n">
                  {{ setting.find((z) => z.id == 15).value }}
                </label>
              </span>
            </v-col>
          </v-row>

          <v-row class="align-items mt-5 pr-1">
            <v-col
              cols="auto"
              class="px-2"
              v-if="setting.find((z) => z.id == 11 && z.value)"
            >
              <div>
                <a
                  :href="setting.find((z) => z.id == 11).value"
                  class="d-flex align-center justify-center"
                >
                  <img src="@/assets/images/Eitaa.png" width="20px" />
                </a>
              </div>
            </v-col>

            <v-col
              cols="auto"
              class="px-2"
              v-if="setting.find((z) => z.id == 10 && z.value)"
            >
              <div>
                <a
                  :href="setting.find((z) => z.id == 10).value"
                  class="d-flex align-center justify-center"
                >
                  <img src="@/assets/images/WhatsApp.png" width="20px" />
                </a>
              </div>
            </v-col>

            <v-col
              cols="auto"
              class="px-2"
              v-if="setting.find((z) => z.id == 12 && z.value)"
            >
              <div>
                <a
                  :href="setting.find((z) => z.id == 12).value"
                  class="d-flex align-center justify-center"
                >
                  <img src="@/assets/images/Telegram.png" width="20px" />
                </a>
              </div>
            </v-col>
          </v-row>
        </v-col>

        <v-col cols="6" lg="4" md="4">
          <h3>دسترسی سریع</h3>
          <ul class="mt-3 pr-4">
            <li
              class="mb-2 p-pointer"
              v-for="menu in menus.filter(
                (z) =>
                  permissions.includes(z.id1) || permissions.includes(z.id2)
              )"
              :key="menu.to"
            >
              <router-link :to="{ name: menu.to }" class="p-fs-n text-p-dark">
                {{ menu.text }}
              </router-link>
            </li>
          </ul>
        </v-col>

        <v-col
          cols="12"
          lg="3"
          md="3"
          v-if="setting.find((z) => z.id == 16).value"
        >
          <h3 class="text-md-center">نماد اعتماد</h3>
          <v-row class="mt-3 mr-md-0 justify-md-center">
            <div class="footer-namad-wrapper ml-2">
              <img src="@/assets/images/sadad.jpg" />
            </div>
            <div
              class="footer-namad-wrapper"
              v-if="setting.find((z) => z.id == 16).value"
              v-html="setting.find((z) => z.id == 16).value"
            />
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import TheAlerts from "@/components/TheAlerts";
import alert from "@/lang/AlertMessages.js";
import label from "@/lang/StaticLabels.js";

export default {
  name: "TheFooter",
  components: {
    TheAlerts,
  },
  computed: {
    ...mapGetters({
      setting: "dropdownX/setting",
      permissions: "identityX/defaultPermissions",
    }),
  },
  data() {
    return {
      alert,
      label,
      menus: [
        {
          to: "AddTransit",
          text: "ثبت تردد",
          id1: 3000101,
          id2: 3000105,
        },
        {
          to: "WaterBillList",
          text: "قبوض آب",
          id1: 30005,
          id2: 3000506,
        },
        {
          to: "ChargeBillList",
          text: "قبوض شارژ",
          id1: 30006,
          id2: 3000605,
        },
        {
          to: "AutomationList",
          text: "پیشنهادات",
          id1: 30007,
          id2: 3000704,
        },
      ],
    };
  },
  watch: {},

  methods: {},
  beforeCreate() {
    this.$store.dispatch("dropdownX/getSetting");
    let getDefault = JSON.parse(localStorage.getItem("selectedRole"));
    this.$store.dispatch("identityX/getUserPermission", getDefault);
  },
};
</script>
